import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Ajv from 'ajv';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class JsonSchemaService {

  ajv: Ajv.Ajv;

  constructor(
    private http: HttpClient
  ) {
    const options: Ajv.Options = {
      allErrors: true,
      verbose: true
    };
    this.ajv = new Ajv(options);
  }

  validate(schemaUrl: string, json: object): Observable<Ajv.ErrorObject[]> {
    return this.http.get(schemaUrl, { responseType: 'text' })
      .pipe(map(schema => {
        const ajvValidate = this.ajv.compile(JSON.parse(schema));
        const valid = ajvValidate(json);
        if (!valid) {
          return ajvValidate.errors;
        }
        return [];
      }));
  }

}
